import React,{useEffect,useState} from "react";
import {Nav} from 'react-bootstrap';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import DecodeData from '../util/DecodeData';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { DashboardOutlined,CreditCardOutlined,
    UserOutlined,SolutionOutlined,ShoppingCartOutlined,
    ScheduleOutlined, ControlOutlined ,
    AreaChartOutlined,ExportOutlined,BellOutlined ,
    CoffeeOutlined,UserSwitchOutlined ,
    TagOutlined, GiftOutlined,
    CheckCircleOutlined
} from '@ant-design/icons';
const { SubMenu } = Menu;

const MenuContainer = styled.div`
    padding-top:50px;
    background-color:#e6e7e8;
    .menu-icon {
        font-size:18px;
        padding-left:30px;
    }
    .menu-item-container {
        background-color:#d3d3d3;
        margin-top:0px !important;
        margin-bottom:0px !important;
        padding-left:65px !important;
        padding-right:0px !important;
    }
    .menu-item {
        font-size:13px;
        padding-right:55px;
    }
    height:100%;
`;

const NavContainer = styled.div`
    /* padding:50px;
    background-color:#e6e7e8;
    word-break:keep-all;
    text-align:center; */
`

function LeftNav () {

    const [GateMenu, setGateMenu] = useState(false);
    const [RefundMenu, setRefundMenu] = useState(false);
    const data = useSelector(state => state.data);

    // 최고 관리자는 문열기 버튼 안보이도록
    // (비상 개방은 지점 관리자가 관리)
    useEffect(()=>{
        DecodeData(data.url)
        .then( result => {
            const level = result.level;
            if(typeof(level) === 'number' && level === 100) {
              setGateMenu(true);
            }
            let cid = result.cid;
            // 핏블리 & 플라이 -
            if(cid !== 'CT20V06145403.2DGI1' && cid !== 'CID00000006'){
                setRefundMenu(true);
            }
        })
        .catch( error => alert(error) )
    },[]);

    return (
      <>
        <MenuContainer>
          <Menu style={{ backgroundColor: "#e6e7e8" }} mode="inline">
            <Menu.Item
              key="1"
              icon={<DashboardOutlined className="menu-icon" />}
            >
              <Link to="/home" className="menu-item">
                대시보드
              </Link>
            </Menu.Item>
            <Menu.Item
              key="2"
              icon={<CreditCardOutlined className="menu-icon" />}
            >
              <Link to="/smartkey" className="menu-item">
                스마트키
              </Link>
            </Menu.Item>

            {RefundMenu ? (
              <SubMenu
                key="Sub2"
                title="PT관리"
                icon={<ScheduleOutlined className="menu-icon" />}
              >
                <Menu.Item
                  key="201"
                  className="menu-item-container"
                  icon={<CheckCircleOutlined />}
                >
                  <Link to="/hg-home" className="menu-item">
                    대시보드
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="202"
                  className="menu-item-container"
                  icon={<CheckCircleOutlined />}
                >
                  <Link to="/reservationBoard" className="menu-item">
                    PT예약보드
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="204"
                  className="menu-item-container"
                  icon={<CheckCircleOutlined />}
                >
                  <Link to="/reservation" className="menu-item">
                    PT예약관리
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="210"
                  className="menu-item-container"
                  icon={<CheckCircleOutlined />}
                >
                  <Link to="/pt_coupon" className="menu-item">
                    PT쿠폰관리
                  </Link>
                </Menu.Item>
                {/* <Menu.Item key="203" className="menu-item-container" icon={<CheckCircleOutlined />}>
                        <Link to="/hg-coupon" className="menu-item">쿠폰관리</Link>
                    </Menu.Item>                */}

                <Menu.Item
                  key="205"
                  className="menu-item-container"
                  icon={<CheckCircleOutlined />}
                >
                  <Link to="/frequency" className="menu-item">
                    프리퀀시관리
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="206"
                  className="menu-item-container"
                  icon={<CheckCircleOutlined />}
                >
                  <Link to="/reward" className="menu-item">
                    티셔츠수령관리
                  </Link>
                </Menu.Item>

                {GateMenu ? null : (
                  <Menu.Item
                    key="207"
                    className="menu-item-container"
                    icon={<CheckCircleOutlined />}
                  >
                    <Link to="/rating" className="menu-item">
                      평가관리
                    </Link>
                  </Menu.Item>
                )}
                <Menu.Item
                  key="208"
                  className="menu-item-container"
                  icon={<CheckCircleOutlined />}
                >
                  <Link to="/report" className="menu-item">
                    평가리포트
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="209"
                  className="menu-item-container"
                  icon={<CheckCircleOutlined />}
                >
                  <Link to="/statistics" className="menu-item">
                    레벨통계
                  </Link>
                </Menu.Item>
              </SubMenu>
            ) : null}

            {RefundMenu ? (
              <SubMenu
                key="Sub1"
                title="푸시관리"
                icon={<BellOutlined className="menu-icon" />}
              >
                <Menu.Item
                  key="101"
                  className="menu-item-container"
                  icon={<TagOutlined />}
                >
                  <Link to="/pushLog" className="menu-item">
                    전송결과
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="102"
                  className="menu-item-container"
                  icon={<TagOutlined />}
                >
                  <Link to="/setup" className="menu-item">
                    담당자설정
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="103"
                  className="menu-item-container"
                  icon={<TagOutlined />}
                >
                  <Link to="/sms" className="menu-item">
                    이용회원
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="104"
                  className="menu-item-container"
                  icon={<TagOutlined />}
                >
                  <Link to="/smsExpire" className="menu-item">
                    만료회원
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="105"
                  className="menu-item-container"
                  icon={<TagOutlined />}
                >
                  <Link to="/smsAll" className="menu-item">
                    모든회원
                  </Link>
                </Menu.Item>
              </SubMenu>
            ) : null}

            <Menu.Item
              key="3"
              icon={<UserSwitchOutlined className="menu-icon" />}
            >
              <Link to="/visit/center/month" className="menu-item">
                방문관리
              </Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<UserOutlined className="menu-icon" />}>
              <Link to="/client" className="menu-item">
                고객관리
              </Link>
            </Menu.Item>
            <Menu.Item
              key="5"
              icon={<SolutionOutlined className="menu-icon" />}
            >
              <Link to="/teacher" className="menu-item">
                강사관리
              </Link>
            </Menu.Item>
            <Menu.Item
              key="6"
              icon={<ShoppingCartOutlined className="menu-icon" />}
            >
              <Link to="/purchase" className="menu-item">
                구매관리 
              </Link>
            </Menu.Item>
            <Menu.Item key="7" icon={<GiftOutlined className="menu-icon" />}>
              <Link to="/item" className="menu-item">
                상품관리 
              </Link>
            </Menu.Item>
            <Menu.Item key="8" icon={<ControlOutlined className="menu-icon" />}>
              <Link to="/center" className="menu-item">
                가맹점관리
              </Link>
            </Menu.Item>
            {RefundMenu ? (
              <Menu.Item
                key="11"
                icon={<CoffeeOutlined className="menu-icon" />}
              >
                <Link to="/discountCoupon" className="menu-item">
                  할인권관리
                </Link>
              </Menu.Item>
            ) : null}

            {RefundMenu ? (
              <>
                <Menu.Item
                  key="9"
                  icon={<AreaChartOutlined className="menu-icon" />}
                >
                  <Link to="/refund" className="menu-item">
                    환불관리
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="10"
                  icon={<ExportOutlined className="menu-icon" />}
                >
                  <Link to="/newGate" className="menu-item">
                    운영시간관리
                  </Link>
                </Menu.Item>
              </>
            ) : (
              <Menu.Item
                key="10"
                icon={<ExportOutlined className="menu-icon" />}
              >
                <Link to="/gate" className="menu-item">
                  출입문잠금
                </Link>
              </Menu.Item>
            )}         
          </Menu>
        </MenuContainer>
      </>
    );
}

function MainNav () {
    return (
        <NavContainer>
            <LeftNav />
        </NavContainer>
    );
}

export default MainNav;